<template>
    <div class="privacy-paragraphs">
        <template v-for="(p, i) in term.paragraphs">
            <div :key="i" style="margin-bottom: 6px">
                <div class="paragraph-title" v-html="p.title"></div>
                <privacy-scroller style="margin-bottom:10px"
                    :paragraph="p"
                />
                <div class="privacy-paragraphs-container" v-show="false">
                    {{p.scrolled}}
                </div>
                <div class="scroll-warning" v-if="!p.scrolled">
                    <span class="scroll-text blink" v-if="!p.scrolled" v-html="p.scrollText"></span>
                </div>
                <privacy-paragraph-flags :paragraph="p" />
            </div>
        </template>
    </div>
</template>

<script>
import PrivacyScroller from './PrivacyScrollerSimple'
import PrivacyParagraphFlags from './PrivacyParagraphFlags'
import {mapState} from 'puex'

export default {
  name: 'PrivacyParagraphs',
  components: {
    PrivacyScroller, PrivacyParagraphFlags
  },
  computed: {
    ...mapState(['term', 'scrollTillTheEnd'])
  },
  props: ['paragraph']
}
</script>

<style lang="scss">
    $warning-height : 20px;
    .privacy-paragraphs{
        .paragraph-title {
            font-size:11px;
            text-align: left;
            padding: 4px;
            font-family: arial;
            font-weight: bold;
        }
        .scroll-warning{
            padding:0px 0 0 22px;
            margin-bottom: 0px;
            text-align: left;
            font-weight: normal;
            color: black;
            font-family: arial;
            font-size: 11px;
            // border: 1px solid #e1e1e1;
            // background-color:#fcecec;
            border-radius: 2px;
        }
    }

    @-webkit-keyframes blinker {
        from {opacity: 1.0;}
        to {opacity: 0.0;}
    }

    @keyframes blinker {
        from {opacity: 1.0;}
        to {opacity: 0.0;}
    }
    .blink{
        animation: blinker 1s steps(5, start) infinite;
        text-decoration: blink;
        -webkit-animation-name: blinker;
        -webkit-animation-duration: 0.6s;
        -webkit-animation-iteration-count:infinite;
        -webkit-animation-timing-function:ease-in-out;
        -webkit-animation-direction: alternate;
    }
</style>



// WEBPACK FOOTER //
// src/components/PrivacyParagraphs.vue